/**
 * The record's dialogs as the address asks for them, and why „Übergeben …"
 * is held — one place for the record's head and the Vorgang's frame, which
 * both offer them under „Mehr …" (final review, M-7). The frame on a spoke
 * leads to the record with the dialog asked for; the record opens it on
 * arrival and takes the parameter out of the address.
 */

/** `/vorgang/:id?uebergeben=1` opens „Übergeben …" on arrival (UX gate round 2, #4). */
export const HANDOVER_PARAM = "uebergeben";

/**
 * `/vorgang/:id?stornieren=1` opens „Vorgang stornieren …" on arrival (spec
 * 2026-10-15 §5) — the register row's menu only knows links, so its entry
 * leads here, as „Übergeben …" leads to `?uebergeben=1`.
 */
export const CANCEL_PARAM = "stornieren";

/** Why „Übergeben …" is held in a finished stage (D-4). */
export const HANDOVER_CLOSED_REASON = "In einem beendeten Stadium lässt sich nicht übergeben.";

/**
 * Why „Übergeben …" is held while a request waits — the waiting line's own
 * words, where that line does not stand (a spoke of the Vorgang).
 */
export function handoverWaitingReason(recipient: string): string {
  return `Übergabe wartet auf ${recipient}.`;
}
